import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    ColorFill: {
        fill: '#fff'
    }
});

const RechargeIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);

    return (
        <>
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 37.8 37.8"
                style={{
                    width: '32px'
                }}
            >
                <g>
                    <path
                        className={classesInline.ColorFill}
                        d="M13.8,17.1h-3v9.7h3c0.3,0,0.6-0.3,0.6-0.6v-8.5C14.4,17.4,14.1,17.1,13.8,17.1z M12.6,25.6
		c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6S12.9,25.6,12.6,25.6z"
                    />
                    <path
                        className={classesInline.ColorFill}
                        d="M24.7,19.6h1.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-6.1c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h1.2
		c0.3-0.7,0.6-2.3,0.6-3.1v-0.6c0-0.7-0.5-1.2-1.2-1.2h-0.1l-0.2,0.9c-0.3,1.2-1,2.5-1.8,3.4c-0.8,1-1.8,1.6-2.7,1.8v7.5l2.3,0.8
		c0.6,0.2,1.1,0.3,1.7,0.3h5.1c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h1.2
		c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-1.2c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h1.2c0.3,0,0.6-0.3,0.6-0.6
		c0-0.3-0.3-0.6-0.6-0.6h-1.2c-0.3,0-0.6-0.3-0.6-0.6C24.1,19.8,24.4,19.6,24.7,19.6z"
                    />
                    <path
                        className={classesInline.ColorFill}
                        d="M18.9,0C8.5,0,0,8.5,0,18.9c0,10.4,8.5,18.9,18.9,18.9c10.4,0,18.9-8.5,18.9-18.9C37.8,8.5,29.3,0,18.9,0z
		 M23.6,10l0.9-0.9c0.2-0.2,0.6-0.2,0.9,0c0.2,0.2,0.2,0.6,0,0.9l-0.9,0.9c-0.2,0.2-0.6,0.2-0.9,0S23.4,10.2,23.6,10z M20.5,7.9
		c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v1.3c0,0.3-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6V7.9z M16.8,9.1c0.2-0.2,0.6-0.2,0.9,0l0.9,0.9
		c0.2,0.2,0.2,0.6,0,0.9c-0.2,0.2-0.6,0.2-0.9,0L16.8,10C16.5,9.8,16.5,9.4,16.8,9.1z M27.8,21.4c0,0.5-0.2,0.9-0.5,1.2
		c0.3,0.3,0.5,0.7,0.5,1.2c0,0.8-0.6,1.5-1.3,1.8c0.1,0.2,0.1,0.4,0.1,0.7c0,1-0.8,1.8-1.8,1.8h-5.1c-0.7,0-1.4-0.1-2.1-0.3L15.4,27
		c-0.3,0.6-0.9,1-1.6,1h-3.6c-0.3,0-0.6-0.3-0.6-0.6V16.5c0-0.3,0.3-0.6,0.6-0.6h3.6c0.8,0,1.4,0.5,1.7,1.2c1.5-0.4,3-2.4,3.5-4.3
		l0.3-1.3c0.1-0.3,0.3-0.5,0.6-0.5h0.6c1.3,0,2.4,1.1,2.4,2.4V14c0,0.6-0.1,2-0.5,3.1h3.5c1,0,1.8,0.8,1.8,1.8
		c0,0.5-0.2,0.9-0.5,1.2C27.6,20.5,27.8,20.9,27.8,21.4z"
                    />
                </g>
            </svg>
        </>
    );
};

export default RechargeIcon;
